import Client from './client';

export default class ProductClassifications extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  postHarmonizeLabels(options = {}) {
    return this.makeRequest(`${this.host}/product_classifications/harmonize_labels`, {
      ...options,
       method: 'POST',
    });
  }

  getOrganizationAndProductByOrganizationIdAndProductId(organizationId, productId, options = {}) {
    return this.makeRequest(`${this.host}/product_classifications/organization/${organizationId}/product/${productId}`, options);
  }

  postOrganizationAndProductByOrganizationIdAndProductId(organizationId, productId, options = {}) {
    return this.makeRequest(`${this.host}/product_classifications/organization/${organizationId}/product/${productId}`, {
      ...options,
       method: 'POST',
    });
  }

  getRefreshDefaultHs6(options = {}) {
    return this.makeRequest(`${this.host}/product_classifications/refresh_default_hs6`, options);
  }

}
